import { render, staticRenderFns } from "./BaseFieldCheckboxList.vue?vue&type=template&id=66da5a02&"
import script from "./BaseFieldCheckboxList.vue?vue&type=script&lang=js&"
export * from "./BaseFieldCheckboxList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports